import { createContext } from "react";

import { BatchMessageStatuses } from "../../BatchMessage.constant";

export const StatusesLabelsContext = createContext<
    Array<keyof typeof BatchMessageStatuses>
>([]);
